import { render } from "./histoireJeux.vue?vue&type=template&id=1a195503&scoped=true"
import script from "./histoireJeux.vue?vue&type=script&lang=js"
export * from "./histoireJeux.vue?vue&type=script&lang=js"

import "./histoireJeux.vue?vue&type=style&index=0&id=1a195503&scoped=true&lang=css"

import exportComponent from "C:\\Users\\gaglo\\OneDrive\\Bureau\\top_chronique\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a195503"]])

export default __exports__